<template>
  <li
      v-for="(item, index) in getMenu"
      :ref="el => dropdownRefs[index] = el"
      :class="{ list: item.list, rent: item.class === 'rent', agent: item.class === 'agent', hover: isCurrentActiveDropdown(index) }"
      :style="{ height: isCurrentActiveDropdown(index) ? heightRefs[index] + 'px' : undefined}"
  >
    <button @click="goFirst(item)" :title="item.title || null">{{ item.text }}</button>
    <ul v-if="item.list && item.list.length">
      <li
          v-for="link in item.list"
      >
        <a :href="link.href" :rel="link.rel">{{ link.text }}</a>
      </li>
    </ul>
    <a v-if="item.list"
       class="header-expand"
       href="#"
       role="button"
       aria-label="Expand List"
       @click="$emit('dropdownSelected', getMenuItemIndex(index))"
    >
      <i class="icon-angle-down"></i>
    </a>
  </li>
</template>

<script>
import {mapGetters} from "vuex";
import mapper from "../../store/mapper/index.js";
import { redirect } from '../../utilities/nojq/_redirect.js';

export default {
  name: 'mvtHeaderMenuPrimary',
  props: ['geo', 'activeDropdown'],
  emits: ['dropdownSelected', 'goFirst'],
  data() {
    return {
      activeIndex: null,
      dropdownRefs: [],
      heightRefs: [],
    }
  },
  computed: {
    ...mapGetters('glb', ['glb']),
    getMenu() {
      return mapper.menu({
        glb: this.glb,
        molang: this.molang,
        geo: this.geo,
      });
    },
  },
  methods: {
    goFirst(item) {
      if (item.href) {
        redirect(item.href);
      } else if (item.list?.[0]?.href) {
        redirect(item.list[0].href);
      }
    },
    getMenuItemIndex(index) {
      return `primary-menu-0${index + 1}`;
    },
    isCurrentActiveDropdown(index) {
      return this.activeDropdown === this.getMenuItemIndex(index);
    },
  },
  watch: {
    async activeDropdown(newVal, oldVal) {
      await this.$nextTick();
      this.dropdownRefs.forEach((el, i) => {
        if(el) {
          this.heightRefs[i] = el.scrollHeight + 1;
        }
      })
    }
  },
};
</script>
